import type { GetSavedOutfitsQuery } from '../../utils/hooks/getSavedOutfits';
export const savedOutfitsMock = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    shoppableLists: [{
      __typename: 'List',
      id: 'saved-outfits',
      listType: 'internal_saved_outfits',
      listItemsByCursor: {
        __typename: 'ListItemConnection',
        edges: [{
          __typename: 'ListItemEdge',
          cursor: 'saved-outfit-1',
          node: {
            __typename: 'ListItem',
            id: 'saved-outfit-1',
            listItemId: 'saved-outfit-1',
            listItemType: 'Outfit',
            availability: null,
            item: {
              __typename: 'Outfit',
              id: 'outfit-1',
              items: [{
                __typename: 'OutfitItem',
                sticker: {
                  __typename: 'ModeStickerLabel',
                  label: 'New Arrival',
                  theme: 'CITRUS'
                },
                laydown: {
                  __typename: 'OutfitItemLaydown',
                  maxHeight: 0.7,
                  maxWidth: 0.45,
                  x: 0.5,
                  y: 0.5,
                  xAnchor: 'center',
                  yAnchor: 'center'
                },
                shopProductVariant: {
                  __typename: 'ShopProductVariant',
                  sku: '2464369',
                  url: '/product/all-saints-lilliana-kettu-dress/V7P8MWMWP',
                  inventory: {
                    __typename: 'ShopInventory',
                    availability: 'AVAILABLE_STOCK'
                  },
                  image: {
                    __typename: 'ShopMedia',
                    id: 'shop-media-2464369',
                    altText: 'Lilliana Kettu Dress',
                    imageUrl: 'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim:9/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1655945007/pqwzpi0eqhikvz8ld2yl.jpg'
                  }
                }
              }]
            }
          }
        }],
        pageInfo: {
          __typename: 'PageInfo',
          endCursor: null,
          hasNextPage: false
        }
      }
    }]
  }
} satisfies GetSavedOutfitsQuery;
export const partiallyUnavailable = {
  __typename: 'ListItemAvailability',
  availableCount: 1,
  totalCount: 3,
  fullyUnavailable: false
} as const;
export const fullyUnavailable = {
  __typename: 'ListItemAvailability',
  availableCount: 0,
  totalCount: 3,
  fullyUnavailable: true
} as const;
export type SavedOutfitEdge = NonNullable<GetSavedOutfitsQuery['client']>['shoppableLists'][number]['listItemsByCursor']['edges'][number];
const [baseSavedOutfitEdge] = savedOutfitsMock.client.shoppableLists[0].listItemsByCursor.edges;
export const savedOutfitEdge = ({
  id,
  availability = null
}: {
  id: string;
  availability?: SavedOutfitEdge['node']['availability'];
}): SavedOutfitEdge => ({
  ...baseSavedOutfitEdge,
  cursor: id,
  node: {
    ...baseSavedOutfitEdge.node,
    id,
    listItemId: id,
    availability,
    item: {
      ...baseSavedOutfitEdge.node.item,
      id: `outfit-${id}`
    }
  }
});
export const buildSavedOutfitsMock = ({
  edges,
  hasNextPage = false,
  endCursor = null
}: {
  edges: SavedOutfitEdge[];
  hasNextPage?: boolean;
  endCursor?: string | null;
}): GetSavedOutfitsQuery => ({
  __typename: 'Query',
  client: {
    __typename: 'Client',
    shoppableLists: [{
      __typename: 'List',
      id: 'saved-outfits',
      listType: 'internal_saved_outfits',
      listItemsByCursor: {
        __typename: 'ListItemConnection',
        edges,
        pageInfo: {
          __typename: 'PageInfo',
          endCursor,
          hasNextPage
        }
      }
    }]
  }
});